export class ImageUtils {

    static DEFAULT_IMAGE = '/images/default_image.png';
}